function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("path", {
  id: "icon-expandable-minus_svg__a",
  d: "M22 2v20H2V2h20zm-4.75 9H6.75c-.414 0-.75.448-.75 1s.336 1 .75 1h10.5c.414 0 .75-.448.75-1s-.336-1-.75-1zm6 13H.75a.75.75 0 01-.75-.75V.75A.75.75 0 01.75 0h22.5a.75.75 0 01.75.75v22.5a.75.75 0 01-.75.75z"
}));

var _ref2 =
/*#__PURE__*/
React.createElement("g", {
  fillRule: "evenodd"
}, React.createElement("mask", {
  id: "icon-expandable-minus_svg__b"
}, React.createElement("use", {
  xlinkHref: "#icon-expandable-minus_svg__a"
})), React.createElement("use", {
  xlinkHref: "#icon-expandable-minus_svg__a"
}), React.createElement("g", {
  mask: "url(#icon-expandable-minus_svg__b)"
}, React.createElement("path", {
  d: "M0 0h24v24H0z"
})));

var SvgIconExpandableMinus = function SvgIconExpandableMinus(props) {
  return React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, props), _ref, _ref2);
};

export default SvgIconExpandableMinus;